import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export default function AdminReports({ api, t }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/reports").then((r) => setItems(r.data)); }, [api]);

  const resolve = async (r) => {
    await api.patch(`/admin/reports/${r.id}/resolve`);
    setItems((arr) => arr.map((x) => x.id === r.id ? { ...x, status: "resolved" } : x));
    toast.success(t("admin.actionOk"));
  };

  if (items.length === 0) return <div className="label-tech">—</div>;

  return (
    <div className="divide-y divide-[var(--ink-200)]">
      {items.map((r) => (
        <div key={r.id} className="py-3 flex items-center gap-3 flex-wrap" data-testid={`admin-report-${r.id}`}>
          <div className="flex-1 min-w-[240px]">
            <div className="font-display">
              <Link to={`/listings/${r.listing_id}`} className="hover:underline">{r.listing_title}</Link>
              {r.status === "resolved" && <span className="tag tag-moss ml-2">{r.status}</span>}
            </div>
            <div className="text-sm text-[var(--ink-700)] mt-1">"{r.reason}"</div>
            <div className="label-tech mt-1">{t("dash.from")} {r.reporter_name}</div>
          </div>
          {r.status === "open" && (
            <button onClick={() => resolve(r)} className="btn-ghost text-xs" data-testid={`admin-resolve-${r.id}`}>{t("admin.report.resolve")}</button>
          )}
        </div>
      ))}
    </div>
  );
}
